<template>
  <div class="footer-contents" style="">
    <div id="web-menu">
      <footer>
        <a href="/"><h1 id="top-titile"><img src="../../assets/logo.png" id="header-image" alt="株式会社weart"></h1></a>
        <!--
          <ul>
            <a href="/"><li>企業概要</li></a>
            <a href="/"><li>サイトマップ</li></a>
            <a href="/"><li>プライバシーポリシー</li></a>
            <a href="/"><li>お問い合わせ</li></a>
          </ul>-->
          <p>© 2020 Weart, Inc. All Rights Reserved</p>
        </footer>
    </div>
    <div id="sp-menu">
      <footer>
        <a href="/"><h1 id="top-titile"><img src="../../assets/logo.png" id="header-image" alt="株式会社weart"></h1></a><br>
        <!--
          <ul>
            <a href="/"><li>企業概要</li></a>
            <a href="/"><li>サイトマップ</li></a>
            <a href="/"><li>プライバシーポリシー</li></a>
            <a href="/"><li>お問い合わせ</li></a>
          </ul>--><br>
          <p>© 2020 Weart, Inc. All Rights Reserved</p>
        </footer>
    </div>
  </div>
</template>
<style scoped>
footer {
height: 100px;
width: 100%;
  background: black;
}
h1 {
  margin-bottom: 0px;
  margin-top: 0px;
}
footer{
  position: relative;
  width: 100%;
}

footer h1 img{
  height: 48px;
  position: absolute;
  top:16px;
  left:5%;
}
#mypage{
  height: 36px;
  position: absolute;
  top:22px;
  right:5%;
}
footer ul img{
  height: 40px;
  width: 40px;
}
a {
  text-decoration: none;
}
footer ul {
  display: inline-block;
  position: absolute;
  top:30px;
  right:10%;
  margin-top: 0px;
  margin-bottom: 0px;
  list-style: none;
}
footer li {
  margin-left: 16px;
  display: inline-block;
  color: white;
}
.cartNum {
  background: orange;
  font-size: 15px;
  padding: 1px;
  width: 16px;
  height: 16px;
  text-decoration: none;
  color: white;
  border-radius: 50%;
}
#sp-menu{
  display: none;
}
footer p{
  color: white;
  bottom: 0px;
  position: absolute;
  width: 20%;
  font-size: 12px;
  font-family: Hiragino Kaku Gothic Pro;
  left: 40%;
}
@media screen and (max-width:780px){
  footer {
height: auto;
width: 100%;
  background: black;
}
footer h1 img{
  height: 40px;
  margin-top: 20px;
}

  footer ul img{
  height: 30px;
  width: 30px;
}
footer ul {
  display: none;
}
#sp-menu{
  display: block;
}
#web-menu{
  display: none;
}
#sp-menu footer h1 img{
  height: 36px;
  position: relative;
  display: block;
  margin:0 auto;
  left: 0%;
}
#sp-menu footer p{
  color: white;
  font-size: 12px;
  padding-top: 5%;
  top: 24px;
  padding-bottom: 5%;
  width: 100%;
  text-align: center;
  left: 0%;
}
}
@media screen and (min-width:781px){

}
</style>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      cartNum: null,
      isCart: false
    }
  },
  created: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Footer.vue